let QualityTypeDto = {
  id: -1,
  qualityType: null,
  detail: null
}

export default QualityTypeDto
